var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('MainMenu'),_vm._v(" "),_c('router-view'),_vm._v(" "),(!_vm.$route.meta.hideFooter)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }